import { claudeModelName } from './claudeModelCatalog';
import { EFFORT_LABELS } from './effortLabels';
import type { LlmProfile } from './types';

/**
 * What a profile runs on, in one quiet line (spec 214):
 * "Claude Opus 5 · Reasoning: High · up to 40 turns".
 *
 * The model by its friendly name when the app knows it, as written otherwise;
 * the reasoning level as the admin form names it; the turn limit only when one
 * is set. The same line wherever a profile is shown — the builder's picker, a
 * step's card, the read-only diagram and Library installs — so a profile reads
 * the same everywhere.
 */
export function profileLine(
  profile: Pick<LlmProfile, 'model' | 'effort' | 'max_turns'>,
): string {
  const facts = profileFacts(profile);
  return [facts.model, facts.reasoning, facts.turns]
    .filter((part) => part !== null)
    .join(' · ');
}

/**
 * The parts `profileLine` joins, for a surface that sets them apart — the AI
 * models card shows the model and reasoning as chips (spec 218). One function, so
 * the card and the line cannot come to say different things.
 */
export function profileFacts(
  profile: Pick<LlmProfile, 'model' | 'effort' | 'max_turns'>,
): { model: string; reasoning: string; turns: string | null } {
  return {
    model: claudeModelName(profile.model) ?? profile.model,
    reasoning: `Reasoning: ${EFFORT_LABELS[profile.effort]}`,
    turns:
      profile.max_turns == null
        ? null
        : `up to ${String(profile.max_turns)} ${profile.max_turns === 1 ? 'turn' : 'turns'}`,
  };
}
